import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dataMeet } from '../../data/data_meet';
import MeetingsTable from '../meetings/MeetingsTable';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState({
    createdMeetings: 0,
    inProgressMeetings: 0,
    completedMeetings: 0,
    totalMinutes: 0
  });
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState('ready'); // 'ready', 'inProgress', 'completed'

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = async () => {
    try {
      setLoading(true);
      const response = await dataMeet.loadMeetings();
      
      if (response.success) {
        const meetings = response.instances || [];
        
        // Calculate metrics
        const createdMeetings = meetings.filter(m => 
          m.state?.toLowerCase() === 'created'
        ).length;
        
        const inProgressMeetings = meetings.filter(m => 
          m.state?.toLowerCase() === 'in-process' || m.state?.toLowerCase() === 'in-progress'
        ).length;
        
        const completedMeetings = meetings.filter(m => 
          m.state?.toLowerCase() === 'completed'
        );
        
        // Calculate total minutes from completed meetings duration
        const totalMinutes = completedMeetings.reduce((total, meeting) => {
          const duration = meeting.duration || 0;
          return total + Math.floor(duration / 60);
        }, 0);

        setMetrics({
          createdMeetings,
          inProgressMeetings,
          completedMeetings: completedMeetings.length,
          totalMinutes
        });
      }
    } catch (error) {
      console.error('Error fetching metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMetricClick = (metricType) => {
    switch (metricType) {
      case 'created':
        // Navigate back to ready meetings view
        setActiveView('ready');
        break;
      case 'completed':
        navigate('/completed-meetings');
        break;
      case 'inProgress':
        // Always allow navigation to in-progress view, even if empty
        setActiveView('inProgress');
        break;
      default:
        // For other metrics, stay on the same page
        break;
    }
  };

  if (loading) {
    return (
      <div className="home-container">
        <div className="metrics-loading">
          <div className="loading-spinner"></div>
          <p>Loading your meeting metrics...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      {/* Metrics Section */}
      <div className="metrics-section">
        <div className="metrics-header">
          <h1>Welcome to Liminal AI Coaching Agent</h1>
          <p>Your AI-powered meeting assistant</p>
        </div>
        
        <div className="metrics-grid">
          <div className="metric-card clickable" onClick={() => handleMetricClick('created')}>
            <div className="metric-icon">
              <i className="ti ti-calendar-plus"></i>
            </div>
            <div className="metric-content">
              <div className="metric-value">{metrics.createdMeetings}</div>
              <div className="metric-label">Ready Meetings</div>
            </div>
          </div>
          
          <div className="metric-card clickable" onClick={() => handleMetricClick('inProgress')}>
            <div className="metric-icon">
              <i className="ti ti-clock"></i>
            </div>
            <div className="metric-content">
              <div className="metric-value">{metrics.inProgressMeetings}</div>
              <div className="metric-label">In Progress</div>
            </div>
          </div>
          
          <div className="metric-card clickable" onClick={() => handleMetricClick('completed')}>
            <div className="metric-icon">
              <i className="ti ti-check"></i>
            </div>
            <div className="metric-content">
              <div className="metric-value">{metrics.completedMeetings}</div>
              <div className="metric-label">Completed</div>
            </div>
          </div>
          
          <div className="metric-card summary-metric">
            <div className="metric-icon">
              <i className="ti ti-time"></i>
            </div>
            <div className="metric-content">
              <div className="metric-value">{metrics.totalMinutes}</div>
              <div className="metric-label">Total Coached Minutes</div>
            </div>
          </div>
        </div>
      </div>

      {/* Meetings Table Section */}
      <div className="meetings-section">
        {activeView !== 'ready' && (
          <div className="view-header">
            <button 
              className="back-button"
              onClick={() => setActiveView('ready')}
            >
              ← Back to Ready Meetings
            </button>
          </div>
        )}
        
        {activeView === 'ready' && (
          <MeetingsTable 
            statusFilter="created" 
            instanceTypeFilter="template"
            title="Meetings Ready to Start"
            showCreateButton={true}
            createButtonPosition="top"
          />
        )}
        
        {activeView === 'inProgress' && (
          <MeetingsTable 
            statusFilter="in-process" 
            instanceTypeFilter={null}
            title="Meetings In Progress"
            showCreateButton={false}
          />
        )}
        

      </div>
    </div>
  );
}

export default Home; 